// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9860 ? "9ebe22f4" : chunkId) + "." + {"2003":"da441011dfd8b9c8","4479":"5c564af344bf27a4","5487":"90ac4c092162a3ac","9860":"037f114d5601e0c9"}[chunkId] + ".js";
};